import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { Router, IsActiveMatchOptions } from '@angular/router';
import {
    AppNavComponent,
    AtlasLegacyNavigationItem,
    ShowHideState,
} from 'atlas-legacy';

@Component({
    standalone: false,
    selector: 'dsp-app-navigation',
    templateUrl: 'app-navigation.component.html',
    styleUrls: ['app-navigation.component.scss'],
})
export class AppNavigationComponent {
    @Input() topNavigation: AtlasLegacyNavigationItem[] | null = [];
    @Input() bottomNavigation: AtlasLegacyNavigationItem[] | null = [];
    @Input() forceState: ShowHideState;
    @Input() iconTooltips = true;
    @Input() sectionTitle: string | false;
    @Input() verticalNavigation = true;

    @ViewChild(AppNavComponent)
    private readonly appNav: AppNavComponent;

    public sideNavExpanded = false;
    public readonly showHideState = ShowHideState;
    public readonly toggleItemLabel = 'Home';

    @HostBinding('class.dsp-mobile-nav-mode')
    get isMobileNavMode(): boolean {
        return !!this.sectionTitle;
    }

    private readonly exactMatch: IsActiveMatchOptions = {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
    };

    public constructor(private readonly router: Router) { }

    public setSideNavExpanded(expanded: boolean): void {
        this.sideNavExpanded = expanded;
        if (this.appNav) {
            this.appNav.sideNavExpanded = expanded;
        }
    }

    public toggleDrawer(): void {
        this.setSideNavExpanded(!this.sideNavExpanded);
    }

    public onNavigationClick(item: AtlasLegacyNavigationItem): void {
        if (!item) {
            return;
        }

        const wasExpanded = this.sideNavExpanded;

        const navItem = item as AtlasLegacyNavigationItem & {
            external?: boolean;
            target?: string;
        };

        if (navItem.external && navItem.path) {
            window.open(navItem.path, navItem.target || '_self');
        } else if (item.path) {
            this.router.navigateByUrl(item.path);
        }

        if (wasExpanded) {
            this.setSideNavExpanded(false);
        }
    }

    public isItemActive(item: AtlasLegacyNavigationItem): boolean {
        return !!item?.path && this.router.isActive(item.path, this.exactMatch);
    }
}
